import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AlertController, LoadingController, ModalController } from '@ionic/angular';
import { PermissionCheckerService } from '@shared/auth/permission-checker.service';
import { CertificationServiceServiceProxy, FarmerDto, FarmerServiceServiceProxy } from '@shared/service-proxies/service-proxies';
import { AppStorageService } from '@shared/storage/app-storage.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProfilePage implements OnInit {
  
  @Input() profile: FarmerDto;
  isLoaded: boolean = false;

  constructor(
    storageService: AppStorageService,
    private modalController: ModalController,
    public alertController: AlertController,
    public loadingController: LoadingController,
    private permissionChecker: PermissionCheckerService,
    private farmerSvc: FarmerServiceServiceProxy,
    private certificationService: CertificationServiceServiceProxy
  ) {
    storageService.IsLoadedSubject.subscribe(x => { 
      if (!this.isLoaded && x) {
        this.isLoaded = true;
      }
    });
  }

  ngOnInit() {
  }

  ok(doEdit: boolean) {
    this.modalController.dismiss({
      doEdit: doEdit,
      farmer: this.profile
    });
  }

  isAdmin() {
    return this.permissionChecker.isGranted("Role.Admin");
  }

  async errorMissingFields() {
    const loading = await this.loadingController.create({
      message: 'Please wait...'
    });
    await loading.present();
    this.farmerSvc.updateFarmerProfileErrorFields(this.profile.id).subscribe(async response => {
      this.farmerSvc.get(this.profile.id).subscribe(async profile => {
        this.profile = profile;
        loading.dismiss();
        const alert = await this.alertController.create({
          header: 'Success',
          message: 'Farmer profile errors / missing fields have been updated',
          buttons: ['OK']
        });
        await alert.present();
      });
    }, async (error) => {
      loading.dismiss();
      const alert = await this.alertController.create({
        header: 'ERROR',
        message: 'There was an issue updating Farmer profile errors / missing fields. Please contact IT for assistance.',
        buttons: ['OK']
      });
      await alert.present();
    });
  }

  async certificationScores() {
    const loading = await this.loadingController.create({
      message: 'Please wait...'
    });
    await loading.present();
    this.certificationService.updateCertificationScores(this.profile.id).subscribe(async response => {
      loading.dismiss();
      const alert = await this.alertController.create({
        header: 'Success',
        message: 'Farmer Certification scores have been updated',
        buttons: ['OK']
      });
      await alert.present();
    }, async (error) => {
      loading.dismiss();
      const alert = await this.alertController.create({
        header: 'ERROR',
        message: 'There was an issue updating Farmer Certification scores. Please contact IT for assistance.',
        buttons: ['OK']
      });
      await alert.present();
    });
  }

}
